import { useEffect, useState } from "react";
import { Input } from "@/shared/ui/input";

interface Props {
  value: string | null | undefined;
  onChange: (next: string | null) => void;
}

/**
 * Local-state text input that debounces its onChange by 400ms so we don't
 * thrash the survey-editor's tree clone on every keystroke. The 1.5s save
 * debounce in useSiteSurveyEditor still kicks in once we propagate.
 */
export function NotesInput({ value, onChange }: Props) {
  const [local, setLocal] = useState(value ?? "");

  useEffect(() => {
    setLocal(value ?? "");
  }, [value]);

  useEffect(() => {
    const t = setTimeout(() => {
      const normalised = local.trim().length === 0 ? null : local;
      if (normalised !== (value ?? null)) {
        onChange(normalised);
      }
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local]);

  return (
    <div className="flex items-center gap-3">
      <label className="text-xs text-muted-foreground w-20 shrink-0">Notes</label>
      <Input
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="Add a note…"
        className="flex-1 h-8 text-sm"
      />
    </div>
  );
}
